export const featuredArtists = [
  {
    id: 1,
    name: 'Eva Ayllón',
    role: 'Intérprete - Música Criolla',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Peruvian%20female%20singer%20with%20elegant%20dark%20attire%2C%20warm%20studio%20lighting%20with%20deep%20red%20and%20black%20background%2C%20dramatic%20shadows%2C%20editorial%20portrait%20photography%2C%20sophisticated%20and%20powerful%20expression%2C%20musical%20artist%20vibe%2C%20high-end%20magazine%20quality&width=800&height=1000&seq=soniem-artist-01&orientation=portrait',
    genre: 'Música Criolla'
  },
  {
    id: 2,
    name: 'Gian Marco',
    role: 'Cantautor - Pop Latino',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Latin%20male%20singer-songwriter%20with%20guitar%2C%20confident%20expression%2C%20warm%20studio%20lighting%20with%20dark%20red%20and%20charcoal%20background%2C%20editorial%20portrait%20photography%2C%20artistic%20and%20passionate%20mood%2C%20high-end%20magazine%20quality%2C%20musician%20portrait&width=800&height=1000&seq=soniem-artist-02&orientation=portrait',
    genre: 'Pop Latino'
  },
  {
    id: 3,
    name: 'Susana Baca',
    role: 'Intérprete - Afroperuana',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20an%20Afro-Peruvian%20female%20singer%20with%20traditional%20elegant%20style%2C%20warm%20dramatic%20lighting%20with%20deep%20burgundy%20and%20black%20background%2C%20editorial%20portrait%20photography%2C%20graceful%20and%20powerful%20presence%2C%20Latin%20American%20music%20icon%2C%20high-end%20magazine%20quality&width=800&height=1000&seq=soniem-artist-03&orientation=portrait',
    genre: 'Afroperuana'
  },
  {
    id: 4,
    name: 'Pedro Suárez-Vértiz',
    role: 'Cantautor - Rock Peruano',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Peruvian%20male%20rock%20musician%20with%20modern%20casual%20style%2C%20dramatic%20studio%20lighting%20with%20dark%20red%20and%20black%20background%2C%20editorial%20portrait%20photography%2C%20charismatic%20and%20confident%20expression%2C%20rock%20star%20vibe%2C%20high-end%20magazine%20quality&width=800&height=1000&seq=soniem-artist-04&orientation=portrait',
    genre: 'Rock Peruano'
  },
  {
    id: 5,
    name: 'Daniela Darcourt',
    role: 'Intérprete - Salsa',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Peruvian%20female%20salsa%20singer%20with%20vibrant%20elegant%20style%2C%20warm%20dramatic%20studio%20lighting%20with%20dark%20burgundy%20and%20black%20background%2C%20editorial%20portrait%20photography%2C%20passionate%20and%20energetic%20expression%2C%20Latin%20music%20artist%2C%20high-end%20magazine%20quality&width=800&height=1000&seq=soniem-artist-05&orientation=portrait',
    genre: 'Salsa'
  },
  {
    id: 6,
    name: 'Tony Succar',
    role: 'Músico - Fusión Latina',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20Peruvian%20male%20Latin%20fusion%20musician%20and%20producer%2C%20modern%20stylish%20look%2C%20dramatic%20studio%20lighting%20with%20deep%20red%20and%20charcoal%20background%2C%20editorial%20portrait%20photography%2C%20confident%20and%20creative%20expression%2C%20high-end%20magazine%20quality&width=800&height=1000&seq=soniem-artist-06&orientation=portrait',
    genre: 'Fusión Latina'
  }
];

export const services = [
  {
    id: 1,
    title: 'Gestión de Regalías',
    description: 'Recaudamos y distribuimos las regalías por la comunicación pública de fonogramas en radio, televisión, cable y locales comerciales.',
    icon: 'ri-money-dollar-circle-line',
    features: ['Recaudación nacional', 'Distribución periódica', 'Transparencia total']
  },
  {
    id: 2,
    title: 'Estudio de Grabación',
    description: 'Beneficio gratuito exclusivo para nuestros afiliados. Espacio profesional equipado para tus producciones musicales.',
    icon: 'ri-mic-line',
    features: ['Equipos profesionales', 'Sin costo para afiliados', 'Reserva programada']
  },
  {
    id: 3,
    title: 'Licencias Musicales',
    description: 'Otorgamos licencias para el uso legal de música a empresas, radios, locales comerciales y plataformas digitales.',
    icon: 'ri-file-music-line',
    features: ['Licencias personalizadas', 'Asesoría legal', 'Cobertura nacional']
  },
  {
    id: 4,
    title: 'Representación Internacional',
    description: 'Miembros de FILAIE con convenios de reciprocidad para gestionar derechos de artistas peruanos en el extranjero.',
    icon: 'ri-global-line',
    features: ['Convenios FILAIE', 'Regalías internacionales', 'Protección global']
  },
  {
    id: 5,
    title: 'Asesoría Legal',
    description: 'Protegemos tus derechos de propiedad intelectual con asesoría especializada en derechos conexos y de autor.',
    icon: 'ri-scales-line',
    features: ['Defensa de derechos', 'Consultoría especializada', 'Registro de obras']
  },
  {
    id: 6,
    title: 'Eventos y Capacitación',
    description: 'Organizamos talleres, conciertos y eventos para el desarrollo profesional de nuestros artistas afiliados.',
    icon: 'ri-calendar-event-line',
    features: ['Talleres formativos', 'Networking artístico', 'Conciertos exclusivos']
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'María Elena Rivas',
    role: 'Cantante afiliada desde 2015',
    quote: 'Gracias a SONIEM he podido recibir regalías que antes desconocía que me correspondían. Su equipo me orientó en todo el proceso de afiliación y ahora recibo mis pagos puntualmente. Es una institución seria y comprometida con los artistas.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Peruvian%20female%20singer%20in%20her%20forties%2C%20warm%20smile%2C%20dark%20hair%2C%20studio%20portrait%20with%20soft%20lighting%20and%20neutral%20gray%20background%2C%20professional%20yet%20approachable%2C%20high%20quality%20headshot&width=200&height=200&seq=soniem-testimonial-01&orientation=squarish'
  },
  {
    id: 2,
    name: 'Carlos Mendoza',
    role: 'Músico ejecutante afiliado desde 2018',
    quote: 'El estudio de grabación gratuito ha sido una bendición para mi carrera. He podido producir tres álbumes sin costo y las regalías que recibo me han permitido dedicarme completamente a la música. SONIEM realmente cumple su misión.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Peruvian%20male%20musician%20in%20his%20thirties%2C%20warm%20genuine%20smile%2C%20dark%20hair%2C%20studio%20portrait%20with%20soft%20lighting%20and%20neutral%20gray%20background%2C%20friendly%20and%20confident%2C%20high%20quality%20headshot&width=200&height=200&seq=soniem-testimonial-02&orientation=squarish'
  },
  {
    id: 3,
    name: 'Lucía Fernández',
    role: 'Cantautora afiliada desde 2020',
    quote: 'Lo que más valoro de SONIEM es la transparencia. Cada trimestre recibo un desglose detallado de mis regalías y sé exactamente de dónde provienen. Además, los convenios internacionales me han abierto puertas que nunca imaginé.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Peruvian%20female%20singer-songwriter%2C%20warm%20confident%20smile%2C%20dark%20hair%2C%20studio%20portrait%20with%20soft%20lighting%20and%20neutral%20gray%20background%2C%20modern%20and%20approachable%2C%20high%20quality%20headshot&width=200&height=200&seq=soniem-testimonial-03&orientation=squarish'
  }
];

export const stats = [
  { value: '3,300+', label: 'Artistas Afiliados' },
  { value: '13', label: 'Años de Trayectoria' },
  { value: '50+', label: 'Países con Convenio' },
  { value: 'S/ 12M+', label: 'Regalías Distribuidas' }
];

export const partners = [
  { name: 'INDECOPI', description: 'Autorización Oficial' },
  { name: 'FILAIE', description: 'Federación Internacional' },
  { name: 'SCD Chile', description: 'Convenio de Reciprocidad' },
  { name: 'AADI-CAPIF', description: 'Convenio Argentina' },
  { name: 'SAYCO', description: 'Convenio Colombia' }
];

export const derechosFonograficosData = {
  hero: {
    titulo: 'Derechos Fonográficos',
    descripcion: 'Los derechos fonográficos protegen a los intérpretes y ejecutantes musicales cuando sus grabaciones sonoras son reproducidas o comunicadas públicamente. SONIEM gestiona, recauda y distribuye estas regalías en todo el territorio peruano.',
    imagen: 'https://readdy.ai/api/search-image?query=Professional%20recording%20studio%20scene%20with%20vintage%20vinyl%20records%20and%20modern%20audio%20equipment%2C%20warm%20dramatic%20lighting%20with%20deep%20red%20and%20charcoal%20black%20tones%2C%20artistic%20composition%20with%20microphone%20and%20mixing%20console%2C%20sophisticated%20music%20industry%20atmosphere%2C%20editorial%20photography%20style%20with%20elegant%20shadows%20and%20rich%20textures&width=1600&height=700&seq=soniem-derechos-fono-hero&orientation=landscape'
  },
  secciones: [
    {
      etiqueta: 'Gestión',
      titulo: '¿Qué son los Derechos Fonográficos?',
      descripcion: 'Los derechos fonográficos son aquellos que corresponden a los artistas intérpretes y ejecutantes por la comunicación pública de sus interpretaciones fijadas en fonogramas. Esto incluye la reproducción de música grabada en radio, televisión, plataformas digitales, locales comerciales, restaurantes, hoteles, discotecas y cualquier espacio público.',
      detalles: [
        'Protección de interpretaciones fijadas en soportes sonoros',
        'Regalías por comunicación pública de fonogramas',
        'Gestión colectiva obligatoria en el Perú',
        'Reconocimiento internacional vía convenios FILAIE'
      ],
      imagen: 'https://readdy.ai/api/search-image?query=Vintage%20vinyl%20record%20collection%20displayed%20on%20a%20dark%20wooden%20table%2C%20dramatic%20warm%20lighting%20with%20deep%20burgundy%20and%20black%20tones%2C%20music%20industry%20heritage%20aesthetic%2C%20rich%20textures%20of%20vinyl%20grooves%20and%20album%20covers%2C%20artistic%20still%20life%20photography%20with%20elegant%20composition%20and%20soft%20shadows&width=800&height=600&seq=soniem-derechos-fono-01&orientation=landscape'
    },
    {
      etiqueta: 'Recaudación',
      titulo: '¿Cómo funciona la recaudación?',
      descripcion: 'SONIEM negocia tarifas con los usuarios de música (emisoras de radio, canales de televisión, locales comerciales, plataformas digitales) y emite licencias que les permiten utilizar el repertorio de nuestros afiliados de manera legal. Los ingresos recaudados se distribuyen periódicamente entre los artistas según criterios objetivos de difusión y uso.',
      detalles: [
        'Tarifas establecidas por el Ministerio de Cultura',
        'Monitoreo constante de medios y plataformas',
        'Distribución trimestral transparente',
        'Reportes detallados de ejecuciones para cada artista'
      ],
      imagen: 'https://readdy.ai/api/search-image?query=Modern%20professional%20recording%20studio%20control%20room%20with%20mixing%20console%20and%20studio%20monitors%2C%20warm%20ambient%20lighting%20with%20red%20accent%20lights%20and%20charcoal%20walls%2C%20sophisticated%20music%20production%20environment%2C%20clean%20and%20high-end%20aesthetic%2C%20editorial%20interior%20photography%20with%20deep%20shadows%20and%20rich%20contrasts&width=800&height=600&seq=soniem-derechos-fono-02&orientation=landscape'
    },
    {
      etiqueta: 'Alcance',
      titulo: 'Cobertura nacional e internacional',
      descripcion: 'A través de nuestra red de monitoreo a nivel nacional y los convenios internacionales de reciprocidad como miembros de FILAIE, nos aseguramos de que tus derechos fonográficos sean protegidos no solo en el Perú, sino también en más de 50 países alrededor del mundo.',
      detalles: [
        'Cobertura en las 24 regiones del Perú',
        'Convenios con sociedades de gestión de +50 países',
        'Recaudación internacional recíproca',
        'Representación de artistas extranjeros en el Perú'
      ],
      imagen: 'https://readdy.ai/api/search-image?query=World%20map%20artistic%20visualization%20with%20musical%20notes%20and%20sound%20waves%20flowing%20across%20continents%2C%20deep%20red%20and%20charcoal%20color%20palette%20with%20gold%20accents%2C%20elegant%20modern%20design%2C%20global%20music%20connection%20concept%2C%20sophisticated%20data%20visualization%20style%20with%20rich%20dark%20background%20and%20subtle%20illuminated%20details&width=800&height=600&seq=soniem-derechos-fono-03&orientation=landscape'
    }
  ],
  artistasEjemplo: [
    {
      nombre: 'Cantantes',
      rol: 'Voz principal y coros',
      imagen: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20singer%20in%20recording%20studio%20with%20headphones%2C%20warm%20dramatic%20lighting%20with%20dark%20red%20background%2C%20passionate%20expression%2C%20music%20industry%20editorial%20photography%2C%20sophisticated%20and%20artistic%20mood%2C%20high-end%20quality&width=400&height=400&seq=soniem-fono-art-01&orientation=squarish'
    },
    {
      nombre: 'Músicos',
      rol: 'Instrumentistas de sesión',
      imagen: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20guitarist%20in%20recording%20studio%20setting%2C%20warm%20dramatic%20lighting%20with%20deep%20charcoal%20background%2C%20focused%20artistic%20expression%2C%20music%20industry%20editorial%20photography%2C%20sophisticated%20mood%2C%20high-end%20magazine%20quality&width=400&height=400&seq=soniem-fono-art-02&orientation=squarish'
    },
    {
      nombre: 'Productores',
      rol: 'Dirección musical',
      imagen: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20music%20producer%20at%20mixing%20console%20in%20studio%2C%20warm%20dramatic%20lighting%20with%20burgundy%20tones%2C%20creative%20and%20focused%20expression%2C%20music%20industry%20editorial%20photography%2C%20sophisticated%20atmosphere%2C%20high-end%20quality&width=400&height=400&seq=soniem-fono-art-03&orientation=squarish'
    },
    {
      nombre: 'Arreglistas',
      rol: 'Adaptaciones musicales',
      imagen: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20musician%20with%20sheet%20music%20in%20studio%20environment%2C%20warm%20dramatic%20lighting%20with%20dark%20red%20and%20black%20tones%2C%20thoughtful%20artistic%20expression%2C%20music%20industry%20editorial%20photography%2C%20sophisticated%20mood%2C%20high-end%20quality&width=400&height=400&seq=soniem-fono-art-04&orientation=squarish'
    }
  ],
  cta: {
    titulo: '¿Eres intérprete o ejecutante musical?',
    descripcion: 'Afíliate a SONIEM y empieza a recibir las regalías que te corresponden por la difusión de tu música. Miles de artistas ya confían en nosotros.',
    boton: 'Afíliate ahora',
    imagen: 'https://readdy.ai/api/search-image?query=Live%20music%20concert%20stage%20with%20dramatic%20red%20and%20charcoal%20lighting%2C%20energetic%20atmosphere%20with%20silhouettes%20of%20musicians%20performing%2C%20passionate%20live%20performance%20scene%2C%20concert%20photography%20style%20with%20warm%20spotlights%20and%20rich%20shadows%2C%20emotional%20and%20powerful%20music%20moment&width=1600&height=500&seq=soniem-derechos-fono-cta&orientation=landscape'
  }
};

export const derechosAudiovisualesData = {
  hero: {
    titulo: 'Derechos Audiovisuales',
    descripcion: 'Los derechos audiovisuales protegen a los artistas intérpretes y ejecutantes cuando sus actuaciones son utilizadas en producciones audiovisuales como películas, series, documentales, videoclips, publicidad y contenido digital. SONIEM vela por una compensación justa en cada uso.',
    imagen: 'https://readdy.ai/api/search-image?query=Professional%20film%20production%20set%20with%20cinema%20camera%20and%20lighting%20equipment%2C%20warm%20dramatic%20lighting%20with%20deep%20red%20and%20charcoal%20black%20tones%2C%20artistic%20composition%20with%20clapperboard%20and%20director%20chair%2C%20sophisticated%20cinematography%20atmosphere%2C%20editorial%20photography%20style%20with%20elegant%20shadows%20and%20cinematic%20mood&width=1600&height=700&seq=soniem-derechos-audio-hero&orientation=landscape'
  },
  secciones: [
    {
      etiqueta: 'Definición',
      titulo: '¿Qué son los Derechos Audiovisuales?',
      descripcion: 'Los derechos audiovisuales protegen las interpretaciones y ejecuciones de los artistas cuando son incorporadas en obras audiovisuales. Esto cubre desde apariciones en películas y series de televisión hasta videoclips musicales, comerciales publicitarios y contenido para plataformas de streaming como Netflix, YouTube, TikTok y más.',
      detalles: [
        'Protección de actuaciones en obras audiovisuales',
        'Regalías por comunicación pública de producciones audiovisuales',
        'Derechos de sincronización musical',
        'Gestión de derechos en plataformas digitales y streaming'
      ],
      imagen: 'https://readdy.ai/api/search-image?query=Professional%20cinema%20camera%20and%20film%20equipment%20on%20set%20with%20warm%20dramatic%20lighting%2C%20deep%20red%20and%20charcoal%20aesthetic%2C%20clapperboard%20and%20vintage%20film%20reels%2C%20sophisticated%20cinematography%20scene%2C%20editorial%20photography%20with%20rich%20shadows%20and%20artistic%20composition&width=800&height=600&seq=soniem-derechos-audio-01&orientation=landscape'
    },
    {
      etiqueta: 'Gestión',
      titulo: '¿Cómo gestionamos tus derechos?',
      descripcion: 'SONIEM negocia y administra las autorizaciones necesarias para que productoras, canales de televisión, plataformas de streaming y agencias de publicidad puedan utilizar legalmente las interpretaciones de nuestros afiliados en sus producciones audiovisuales, asegurando una remuneración justa y equitativa.',
      detalles: [
        'Negociación de tarifas con productoras y canales',
        'Gestión de licencias de sincronización',
        'Monitoreo de uso en plataformas digitales',
        'Distribución periódica y transparente de regalías'
      ],
      imagen: 'https://readdy.ai/api/search-image?query=Professional%20film%20editing%20suite%20with%20multiple%20monitors%20displaying%20timeline%2C%20warm%20ambient%20lighting%20with%20red%20accent%20and%20charcoal%20walls%2C%20sophisticated%20post-production%20environment%2C%20clean%20modern%20aesthetic%2C%20editorial%20interior%20photography%20with%20rich%20contrasts%20and%20professional%20atmosphere&width=800&height=600&seq=soniem-derechos-audio-02&orientation=landscape'
    }
  ],
  formatos: [
    {
      icono: 'ri-movie-line',
      nombre: 'Cine y Películas',
      descripcion: 'Largometrajes, cortometrajes y producciones cinematográficas exhibidas en salas de cine o plataformas.'
    },
    {
      icono: 'ri-tv-line',
      nombre: 'Televisión',
      descripcion: 'Series, telenovelas, programas de entretenimiento y transmisiones en canales de señal abierta y cable.'
    },
    {
      icono: 'ri-play-circle-line',
      nombre: 'Streaming',
      descripcion: 'Contenido en Netflix, Amazon Prime, Disney+, HBO Max, YouTube y otras plataformas digitales.'
    },
    {
      icono: 'ri-advertisement-line',
      nombre: 'Publicidad',
      descripcion: 'Comerciales de TV, spots digitales, cuñas radiales y campañas publicitarias en todos los medios.'
    },
    {
      icono: 'ri-music-line',
      nombre: 'Videoclips',
      descripcion: 'Videos musicales, visualizers, lyric videos y contenido audiovisual musical para todas las plataformas.'
    },
    {
      icono: 'ri-smartphone-line',
      nombre: 'Redes Sociales',
      descripcion: 'Contenido para TikTok, Instagram Reels, YouTube Shorts, Facebook Watch y otras redes sociales.'
    }
  ],
  cta: {
    titulo: 'Protege tus interpretaciones en el mundo audiovisual',
    descripcion: 'Si eres músico, cantante o ejecutante y tu imagen o interpretación aparece en producciones audiovisuales, tienes derecho a una compensación. Afíliate a SONIEM y asegura tus derechos.',
    boton: 'Quiero afiliarme',
    imagen: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20film%20director%20working%20on%20set%20with%20camera%20crew%2C%20dramatic%20red%20and%20charcoal%20lighting%2C%20professional%20movie%20production%20atmosphere%2C%20warm%20spotlights%20and%20rich%20shadows%2C%20film%20industry%20editorial%20photography%2C%20sophisticated%20and%20powerful%20cinematic%20mood&width=1600&height=500&seq=soniem-derechos-audio-cta&orientation=landscape'
  }
};

export const derechosPageData = {
  hero: {
    titulo: 'Derechos que gestionamos',
    subtitulo: 'SONIEM representa y administra los derechos de los artistas intérpretes y ejecutantes musicales conforme a su Estatuto, la autorización otorgada por INDECOPI y la legislación nacional e internacional aplicable.',
    modulos: [
      {
        titulo: 'Derechos sobre Fonogramas',
        icono: 'ri-disc-line',
        descripcion: 'Gestionamos los derechos de remuneración por la comunicación pública de interpretaciones fijadas en fonogramas.',
        imagen: 'https://readdy.ai/api/search-image?query=Professional%20recording%20studio%20scene%20with%20musicians%20performing%20live%2C%20vintage%20microphones%20and%20analog%20equipment%2C%20warm%20dramatic%20lighting%20with%20deep%20red%20and%20charcoal%20black%20tones%2C%20artistic%20documentary%20photography%20style%2C%20passionate%20musical%20performance%20captured%20in%20elegant%20studio%20environment%2C%20rich%20textures%20and%20sophisticated%20atmosphere&width=800&height=500&seq=soniem-derechos-card-fono&orientation=landscape',
        slug: 'fonogramas'
      },
      {
        titulo: 'Derechos sobre Obras Audiovisuales',
        icono: 'ri-film-line',
        descripcion: 'Administramos los derechos de los artistas cuyas interpretaciones son incorporadas en producciones audiovisuales.',
        imagen: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20film%20production%20set%20with%20professional%20camera%20crew%20capturing%20an%20artistic%20performance%2C%20dramatic%20red%20and%20charcoal%20mood%20lighting%2C%20sophisticated%20movie%20production%20atmosphere%2C%20documentary%20style%20photography%2C%20elegant%20composition%20with%20warm%20shadows%20and%20rich%20cinematic%20textures&width=800&height=500&seq=soniem-derechos-card-audio&orientation=landscape',
        slug: 'audiovisuales'
      }
    ]
  },
  selector: {
    titulo: '¿Cómo podemos ayudarte?',
    opciones: [
      {
        tipo: 'artista',
        icono: 'ri-mic-2-line',
        titulo: 'Soy Artista',
        descripcion: 'Quiero registrar mis interpretaciones y conocer mis derechos.',
        target: 'fonogramas'
      },
      {
        tipo: 'usuario',
        icono: 'ri-building-2-line',
        titulo: 'Soy Usuario',
        descripcion: 'Necesito información sobre el uso de música o interpretaciones audiovisuales.',
        target: 'fonogramas'
      }
    ]
  },
  fonogramas: {
    heroImagen: 'https://readdy.ai/api/search-image?query=Professional%20recording%20studio%20interior%20with%20musicians%20performing%20live%20session%2C%20vintage%20analog%20mixing%20console%20and%20modern%20equipment%20blend%2C%20warm%20dramatic%20lighting%20with%20deep%20red%20and%20charcoal%20tones%2C%20artistic%20documentary%20photography%2C%20soulful%20musical%20atmosphere%2C%20elegant%20composition%20with%20rich%20shadows%20and%20professional%20studio%20environment%2C%20editorial%20quality&width=1600&height=600&seq=soniem-fonogramas-hero&orientation=landscape',
    introduccion: {
      titulo: 'Derechos sobre Fonogramas',
      parrafo1: 'Las interpretaciones fijadas en fonogramas generan derechos de remuneración cuando son comunicadas públicamente. Estos derechos corresponden a los artistas intérpretes y ejecutantes que participaron en la grabación sonora.',
      parrafo2: 'SONIEM representa estos derechos conforme a su Estatuto y administra los derechos patrimoniales que corresponden a los artistas intérpretes y ejecutantes, gestionando la recaudación, identificación de titulares y distribución de las remuneraciones.'
    },
    infografia: [
      { etiqueta: 'USUARIO', descripcion: 'Utiliza fonogramas en su actividad comercial', icono: 'ri-building-line', color: 'bg-secondary-100 text-secondary-900' },
      { etiqueta: 'UNIMPRO', descripcion: 'Recauda las remuneraciones por comunicación pública', icono: 'ri-bank-line', color: 'bg-accent-100 text-accent-900' },
      { etiqueta: 'SONIEM', descripcion: 'Administra, identifica titulares y distribuye regalías', icono: 'ri-shield-check-line', color: 'bg-primary-100 text-primary-900' },
      { etiqueta: 'ARTISTA', descripcion: 'Recibe la remuneración que le corresponde', icono: 'ri-star-line', color: 'bg-foreground-900 text-white' }
    ],
    textoInstitucional: {
      titulo: 'Marco legal de la gestión colectiva en el Perú',
      parrafo1: 'En el Perú, la recaudación por la comunicación pública de fonogramas es realizada por UNIMPRO, conforme al modelo de gestión colectiva desarrollado en el marco de la Decisión 351 de la Comunidad Andina, la legislación nacional aplicable y las resoluciones emitidas por INDECOPI.',
      parrafo2: 'SONIEM representa a los artistas intérpretes y ejecutantes y administra los derechos que les corresponden, efectuando la identificación de titulares y la distribución de las remuneraciones recibidas.'
    },
    usuarios: [
      { nombre: 'Radio', icono: 'ri-radio-line' },
      { nombre: 'Televisión', icono: 'ri-tv-line' },
      { nombre: 'Discotecas', icono: 'ri-music-line' },
      { nombre: 'Bares', icono: 'ri-goblet-line' },
      { nombre: 'Restaurantes', icono: 'ri-restaurant-line' },
      { nombre: 'Hoteles', icono: 'ri-hotel-line' },
      { nombre: 'Centros comerciales', icono: 'ri-store-2-line' },
      { nombre: 'Eventos', icono: 'ri-calendar-event-line' },
      { nombre: 'Plataformas digitales', icono: 'ri-smartphone-line' }
    ],
    botones: {
      usuario: {
        texto: 'Necesito información sobre el pago por comunicación pública',
        boton: 'Soy Usuario',
        color: 'bg-primary-500 hover:bg-primary-600 text-white'
      },
      artista: {
        texto: 'Registrar mis interpretaciones y administrar mis derechos',
        boton: 'Soy Artista',
        color: 'bg-foreground-900 hover:bg-foreground-800 text-white'
      }
    }
  },
  audiovisuales: {
    heroImagen: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20professional%20film%20production%20set%20with%20director%20and%20performers%20in%20an%20artistic%20scene%2C%20dramatic%20warm%20lighting%20with%20deep%20burgundy%20and%20charcoal%20tones%2C%20sophisticated%20movie%20set%20atmosphere%2C%20documentary%20style%20behind%20the%20scenes%20photography%2C%20elegant%20composition%20with%20rich%20textures%20and%20professional%20cinema%20equipment%2C%20artistic%20mood&width=1600&height=600&seq=soniem-audiovisuales-hero&orientation=landscape',
    introduccion: {
      titulo: 'Derechos sobre Obras Audiovisuales',
      parrafo1: 'Las interpretaciones incorporadas en obras audiovisuales también generan derechos reconocidos por la legislación peruana. Estos derechos protegen a los artistas cuando sus actuaciones aparecen en películas, series, documentales, videoclips, publicidad y cualquier producción audiovisual.',
      parrafo2: 'SONIEM cuenta con facultades estatutarias para gestionar estos derechos conforme a su Estatuto y a la autorización otorgada por INDECOPI, velando por una compensación justa en cada tipo de uso audiovisual.'
    },
    formatos: [
      { nombre: 'Películas', icono: 'ri-movie-2-line', descripcion: 'Largometrajes y cortometrajes exhibidos en salas de cine y plataformas digitales.' },
      { nombre: 'Series', icono: 'ri-tv-2-line', descripcion: 'Producciones seriadas para televisión abierta, cable y plataformas de streaming.' },
      { nombre: 'Programas de televisión', icono: 'ri-live-line', descripcion: 'Emisiones en vivo y grabadas en canales de señal abierta y por suscripción.' },
      { nombre: 'Documentales', icono: 'ri-camera-lens-line', descripcion: 'Producciones documentales distribuidas en todos los formatos y plataformas.' },
      { nombre: 'Videoclips', icono: 'ri-music-2-line', descripcion: 'Videos musicales, visualizers y contenido audiovisual para plataformas digitales.' },
      { nombre: 'Conciertos grabados', icono: 'ri-live-line', descripcion: 'Registros audiovisuales de presentaciones en vivo y conciertos filmados.' },
      { nombre: 'Streaming', icono: 'ri-play-circle-line', descripcion: 'Contenido en Netflix, Prime Video, Disney+, HBO Max, YouTube y otras plataformas.' },
      { nombre: 'Publicidad audiovisual', icono: 'ri-advertisement-line', descripcion: 'Spots comerciales, campañas digitales y contenido publicitario para todos los medios.' }
    ],
    gestionBox: {
      titulo: 'Desarrollo de la Gestión Audiovisual',
      texto: 'SONIEM viene desarrollando la implementación de la gestión colectiva de los derechos derivados de las interpretaciones incorporadas en obras audiovisuales, de conformidad con su Estatuto, la autorización de funcionamiento otorgada por INDECOPI y el marco jurídico nacional e internacional. El objetivo es garantizar una protección efectiva y una adecuada gestión de los derechos de los artistas intérpretes y ejecutantes en el ámbito audiovisual.'
    },
    botones: {
      usuario: {
        texto: 'Solicitar información sobre licencias y obligaciones derivadas del uso de interpretaciones incorporadas en obras audiovisuales.',
        boton: 'Soy Usuario',
        color: 'bg-primary-500 hover:bg-primary-600 text-white'
      },
      artista: {
        texto: 'Registrar mis interpretaciones incorporadas en obras audiovisuales.',
        boton: 'Soy Artista',
        color: 'bg-foreground-900 hover:bg-foreground-800 text-white'
      }
    }
  }
};